import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import sortIcon from "../media/sort-icon.svg";
import searchIcon from "../media/search-icon.svg";
import orangeSortIcon from "../media/orange-sort-icon.svg";
import { LoadingComponent } from "../App";
import { NavLink } from "react-router-dom";
import ReservationsCalendar from "./calendar/ReservationsCalendar";

const ReservationTable = ({
  title,
  subtitle, // opcjonalny napis pod tytułem
  columns, // [{ key: "employee", label: "Pracownik" }, ...]
  data,
  loading,
  error,
  onSort,
  sortedColumn,
  sortOrder,
  searchBy,
  setSearchBy,
  searchTerm,
  setSearchTerm,
  searchOptions, // [{ key: "employee", label: "Pracownik" }, ...]
  expandedRows = [], // <--- nowy props
  onRowClick, // (row, idx)
  onMonthAndYearChange, // Callback for month/year changes
  renderExpandedRow, // (row, idx)
  button, // optional: { label, onClick, icon }
  adminButton, // optional: { link, label } for admin management
  legendItems = [], // New prop for legend items
  legendTitle = null, // Optional title for the legend
  showOnlyMine = false, // New prop for "only mine" filter
  onToggleOnlyMine, // Callback for toggling "only mine" filter
  currentDate, // Add prop for current date
}) => {
  const { t, i18n } = useTranslation();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [hover, setHover] = useState(false);
  const [adminHover, setAdminHover] = useState(false);
  // Only show calendar toggle if columns are provided (meaning table view is available)
  const hasTableView = columns && columns.length > 0;
  const [showCalendar, setShowCalendar] = useState(true);

  // const [currentDate, setCurrentDate] = useState(new Date());

  // Callback function to receive date changes from ReservationsCalendar
  const handleCalendarDateChange = (date) => {
    if (onMonthAndYearChange) {
      onMonthAndYearChange(date);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="cars-container">
      <div
        className={`header ${showCalendar ? "calendar-mode" : "table-mode"}`}
      >
        <h1>{title}</h1>
        {subtitle && (
          <div
            style={{
              color: "#c7c7c7",
              fontSize: "1.25rem",
              fontWeight: 400,
              marginTop: 0,
            }}
          >
            {subtitle}
          </div>
        )}
        {/* --- NEW BUTTON --- */}
        {button && button.createLink && (
          <NavLink className="create-button" to={button.createLink}>
            {button.createLabel ||
              (button.createLink?.includes("/samochody")
                ? t("reservations.cars.makeReservation")
                : button.createLink?.includes("/sale-konferencyjne")
                  ? t("reservations.rooms.makeReservation")
                  : t("reservations.cars.makeReservation"))}
          </NavLink>
        )}
        {/* --- ADMIN BUTTON --- */}
        {adminButton && adminButton.link && (
          <NavLink
            className="admin-manage-button"
            to={adminButton.link}
            onMouseEnter={() => setAdminHover(true)}
            onMouseLeave={() => setAdminHover(false)}
          >
            <div
              className="icon"
              style={{
                backgroundImage: `url(${adminHover ? orangeSortIcon : sortIcon})`,
                transform: adminHover ? "scale(1.2)" : "rotate(270deg)",
              }}
            ></div>
            {adminButton.label || "Zarządzaj"}
          </NavLink>
        )}

        <div className="right-side">
          <div className="reservation">
            {hasTableView && (
              <button
                className="booking-button"
                onClick={() => setShowCalendar((v) => !v)}
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
              >
                <div
                  className="icon"
                  style={{
                    backgroundImage: `url(${hover ? orangeSortIcon : sortIcon})`,
                    transform: hover ? "scale(1.2)" : "rotate(270deg)",
                  }}
                ></div>
                {showCalendar
                  ? t("reservations.calendar.hide")
                  : t("reservations.calendar.show")}
              </button>
            )}

            {/* --- MOBILE RESERVATION BUTTON --- */}
            {button && button.createLink && (
              <NavLink
                className="mobile-reservation-button"
                to={button.createLink}
              >
                {button.createLabel ||
                  (button.createLink?.includes("/samochody")
                    ? t("reservations.cars.makeReservation")
                    : button.createLink?.includes("/sale-konferencyjne")
                      ? t("reservations.rooms.makeReservation")
                      : t("reservations.cars.makeReservation"))}
              </NavLink>
            )}
          </div>
          {!showCalendar && hasTableView && (
            <div className="searching">
              <input
                type="text"
                placeholder={`${t("reservations.common.searchBy", {
                  field:
                    (
                      searchOptions.find((opt) => opt.key === searchBy)
                        ?.label || ""
                    )
                      .charAt(0)
                      .toLowerCase() +
                    (
                      searchOptions.find((opt) => opt.key === searchBy)
                        ?.label || ""
                    ).slice(1),
                })}`}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <div
                className="search-icon"
                style={{ backgroundImage: `url(${searchIcon})` }}
              ></div>
              <div
                className={`dropdown ${isDropdownOpen ? "open" : ""}`}
                ref={dropdownRef}
              >
                <button
                  className="search-toggle-btn"
                  onClick={() => setIsDropdownOpen((v) => !v)}
                >
                  {searchOptions.find((opt) => opt.key === searchBy)?.label ||
                    ""}
                </button>
                <div className="dropdown-content">
                  {searchOptions.map((opt) => (
                    <button
                      key={opt.key}
                      className="dropdown-item"
                      onClick={() => {
                        setSearchBy(opt.key);
                        setIsDropdownOpen(false);
                      }}
                    >
                      {opt.label}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {loading ? (
        <LoadingComponent />
      ) : error ? (
        <div className="error-message">
          {t("common.error")}: {error}
        </div>
      ) : showCalendar || !hasTableView ? (
        <ReservationsCalendar
          events={data || []}
          loading={loading}
          error={error}
          onDateSwitch={handleCalendarDateChange}
          legendItems={legendItems}
          legendTitle={legendTitle}
          showOnlyMine={showOnlyMine}
          onToggleOnlyMine={onToggleOnlyMine}
          initialDate={currentDate}
        />
      ) : (
        // <div className="table-wrapper">
        <table className="cars-table">
          <thead>
            <tr>
              {columns.map((col) => (
                <th
                  key={col.key}
                  onClick={() => onSort && onSort(col.key)}
                  className={sortedColumn === col.key ? "sorted-column" : ""}
                >
                  {col.label}
                  <img
                    src={sortIcon}
                    alt="Sort Icon"
                    className={`sort-icon ${
                      sortedColumn === col.key ? "rotated" : ""
                    }`}
                  />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.length > 0 ? (
              data.map((row, idx) => {
                const reservation = row.resource ? row.resource : row;
                const localeCode = i18n.language === "en" ? "en-GB" : "pl-PL";
                return (
                  <React.Fragment key={idx}>
                    <tr
                      onClick={
                        onRowClick ? () => onRowClick(row, idx) : undefined
                      }
                      className={
                        expandedRows.includes(idx) ? "expanding" : undefined
                      }
                      style={{ cursor: onRowClick ? "pointer" : undefined }}
                    >
                      {columns.map((col) => (
                        <td key={col.key}>
                          {col.key === "carInfo" && reservation.car
                            ? `${reservation.car.make} ${reservation.car.model} ${reservation.car.licensePlate}`
                            : col.key === "car" && reservation.car
                              ? `${reservation.car.make} ${reservation.car.model} ${reservation.car.licensePlate}`
                              : (col.key === "fromDate" ||
                                    col.key === "toDate") &&
                                  reservation[col.key]
                                ? new Date(
                                    reservation[col.key],
                                  ).toLocaleDateString(localeCode, {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                  }) +
                                  ", " +
                                  new Date(
                                    reservation[col.key],
                                  ).toLocaleTimeString(localeCode, {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                  })
                                : (col.key === "fromTime" ||
                                      col.key === "toTime") &&
                                    reservation[col.key]
                                  ? reservation[col.key].replace(
                                      /^(\d{2}:\d{2}):\d{2}$/,
                                      "$1",
                                    )
                                  : reservation[col.key]}
                        </td>
                      ))}
                    </tr>
                    {expandedRows.includes(idx) && renderExpandedRow ? (
                      <tr className="list" key={`expanded-${idx}`}>
                        <td colSpan={columns.length}>
                          {renderExpandedRow(row, idx)}
                        </td>
                      </tr>
                    ) : null}
                  </React.Fragment>
                );
              })
            ) : (
              <tr>
                <td colSpan={columns.length}>
                  {t("reservations.common.noResults")}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default ReservationTable;
